import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter, Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {BehaviorSubject, combineLatest, Observable, of, pairwise, startWith, Subscription} from 'rxjs';
import {
  ApDynformsConfigFieldset
}                                                                                          from '../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {
  ApDynGridColumnConfigBase,
  ApDynGridColumnHideConfig
}                                                                                          from '../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {
  ApDynGridPagerWizardBreadcrumbsStepper,
  ApDynGridPagerWizardButton,
  ApDynGridPagerWizardConfig
}                                                                                          from '../../ap-dyngrids/config/ap-dyn-grid-pager-wizard-config';
import {
  ApDynComponentComponent
}                                                                                          from '../../ap-dyncomponent/ap-dyncomponent.component';
import {
  debounceTime,
  delay,
  distinctUntilChanged,
  filter,
  map,
  tap
}                                                                                          from 'rxjs/operators';
import {
  ApDynGridStatusColumnConfig
}                                                                                          from '../../ap-dyngrids/config/ap-dyn-grid-status-column-config';
import {
  ApDynGridPropertyColumnConfig,
  FilterType
}                                                                                          from '../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {
  MapViewMode
}                                                                                          from '../../ap-interface';
import {
  ApDynGridGroupColumnConfig
}                                                                                          from '../../ap-dyngrids/config/ap-dyn-grid-group-column-config';
import {
  FieldStore
}                                                                                          from '../../stores/farm/field.store';
import {
  MapViewStore
}                                                                                          from '../../stores/layout/mapview.store';
import {
  LanguageStore
}                                                                                          from '../../stores/translation/language.store';
import {
  CropRotationStore
}                                                                                          from '../../stores/farm/crop.rotation.store';
import {
  CampaignYearStore
}                                                                                          from '../../stores/login/campaignyear.store';
import {
  CropTypeStore
}                                                                                          from '../../stores/base-data/crop.types.store';
import {
  ApDynGridEditColumnConfig
}                                                                                          from '../../ap-dyngrids/config/ap-dyn-grid-edit-column-config';
import {
  FormStore,
  IEntryComponent
}                                                                                          from '../../stores/layout/form.store';
import {
  ApGuidUtil,
  ApTimeSpanUtil,
  GetRoundNumericPipe
}                                                                                          from '../../ap-utils';
import {
  SettingsStore
}                                                                                          from '../../stores/base-data/settings.store';
import {
  GetRoundNumericService
}                                                                                          from '../../ap-utils/service/get-round-numeric.service';
import {
  ApplicationMapConfig
}                                                                                          from './ap-n-fertilization-planning-configs/application-map.config';
import {
  TargetRateConfig
}                                                                                          from './ap-n-fertilization-planning-configs/target-rate.config';
import {
  NFertilizationConfig
}                                                                                          from './ap-n-fertilization-planning-configs/n-fertilization.config';
import {
  RapeFertilizationConfig
}                                                                                          from './ap-n-fertilization-planning-configs/rape-fertilization.config';
import {
  CurveCreator
}                                                                                          from './helpers/curve-creator';
import {
  Create,
  ObjectFactory
}                                                                                          from 'ts-tooling';
import {
  TranslationStore
}                                                                                          from '../../stores/translation/translation.store';
import {
  NFertilizationStore
}                                                                                          from '../../stores/n-fertilization/n-fertilization.store';
import {
  ApGetCropService
}                                                                                          from '../../stores/services/ap-get-crop.service';
import {
  LoginStore
}                                                                                          from '../../stores/login/login.store';
import {
  BoniturConfig
}                                                                                          from './ap-n-fertilization-planning-configs/bonitur.config';
import {
  ModalDialogStore
}                                                                                          from '../../stores/dialog/modal.dialog.store';
import {
  IModalDialogData,
  ModalDialogButtonDisable
}                                                                                          from '../../ap-interface/interfaces/ap-modaldialog-data.interface';
import {
  OperationModesEnum,
  OperationModesStore
}                                                                                          from '../../stores/common/operation-modes.store';
import {
  ApplicationModesEnum,
  ApplModesStore
}                                                                                          from '../../stores/common/appl-modes.store';
import {
  GeneralConfig
}                                                                                          from './ap-n-fertilization-planning-configs/general.config';
import {
  ApDateService
}                                                                                          from '../../ap-core/services/ap-date-service';
import {
  UnitsStore
}                                                                                          from '../../stores/common/units.store';
import {
  NotifyStore
}                                                                                          from '../../stores/dialog/notify.store';
import {
  MapStore
}                                                                                          from '../../stores/map/map.store';
import {
  RouterStore
}                                                                                          from '../../stores/router/router.store';
import {
  IGridStatus
}                                                                                          from '../../ap-interface/interfaces/ap-grid-status.interface';
import {
  StatisticStore
}                                                                                          from '../../stores/statistic/statistic.store';
import {
  NFertilizationService
}                                                                                          from '../../services/data/n-fertilization.service';
import {
  EcStageMinMax,
  INFertilizationPlanFieldToSelectGridItem,
  INFertilizationPlanningPlanBookData,
  NPlanningEntryComponentData,
  SelectedFieldsInfo
}                                                                                          from './types/n-fertilization-planning-entry.types';
import {
  ApBaseWizardSteps
}                                                                                          from '../../ap-utils/enums/ap-base-wizard-steps';
import {
  BasicFertilisationSummariesStore
}                                                                                          from '../../stores/taskmanagement/basic.fertilisation.summaries.store';
import {
  SensorStore
}                                                                                          from '../../stores/sensor/sensor.store';
import {
  MapFactoryStyler
}                                                                                          from '../../map-factory/style';
import {
  NFertilizationPlanningEntryService
}                                                                                          from './services/n-fertilization-planning-entry.service';
import {
  ApElementType
}                                                                                          from '../../ap-interface/enums/ap-elements-type.enum';
import {
  ApplicationMapAbsoluteConfig
}                                                                                          from './ap-n-fertilization-planning-configs/application-map-absolute.config';
import {
  ApplicationSettingsStore
}                                                                                          from '../../stores/agronomic/application-settings.store';
import {
  NFertilizationCommonEntryService
}                                                                                          from './services/n-fertilization-common-entry.service';
import {
  nameOf
}                                                                                          from '../../ap-core/utils/ap-name-of';
import {
  IOperationModeAppSetting
}                                                                                          from '../../types/application-settings.types';
import {
  ScanService
}                                                                                          from '../../services/data/scan.service';
import {
  BestScanData,
  BestScanType
}                                                                                          from '../../types/scan.types';
import {
  NFertilizationPlantProtectionService
}                                                                                          from '../../services/data/n-fertilization-plant-protection.service';
import {
  ApplicationSettingsService
}                                                                                          from '../../services/data/application-settings.service';
import {
  GetRoundNumericPipeConfig
}                                                                                          from '../../ap-utils/configs/get-round-numeric.pipe.config';
import {
  UniformConfig
}                                                                                          from './ap-n-fertilization-planning-configs/uniform.config';
import {
  TargetMapPerPlanConfig
}                                                                                          from './ap-n-fertilization-planning-configs/target-map-per-plan.config';
import {
  ApColumnState
}                                                                                          from '../../ap-interface/enums/ap-column-state.enum';
import {
  FieldService
}                                                                                          from '../../field-management/components/field.service';
import {
  TimeAreaService
}                                                                                          from '../../services/data/time-area.service';
import {
  FormatType
}                                                                                          from '../../ap-utils/types/ap-format-duration.types';
import {
  ApTranslationService
}                                                                                          from '../../ap-utils/service/ap-translation.service';
import {
  ApTooltipContentService
}                                                                                          from '../../ap-utils/service/ap-tooltip-content.service';
import {
  TimeFormatPipe
}                                                                                          from '../../ap-utils/pipes/ap-format-duration.pipe';
import {
  CroptypeService
}                                                                                          from '../../services/data/croptypes.service';
import {
  AgriportConstantsService
}                                                                                          from '../../services/common/agriport-constants.service';
import {
  AgriportConstantsEnum
}                                                                                          from '../../ap-interface/enums/ap-agriport-constants.enum';
import {
  FieldScanData
}                                                                                          from '../../types/n-fertilization-plant-protection.types';
import IGuid = System.IGuid;
import INFertilizationPlanBook = Data.TaskManagement.INFertilizationPlanBook;
import INFertilizationSummary = Data.TaskManagement.INFertilizationSummary;
import ICropTypes = Data.BaseData.ICropTypes;
import ApValidationLevel = Data.Api.Validation.ApValidationLevel;
import ISensorFieldData = Data.Sensor.ISensorFieldData;
import INPlanningData = Data.NFertilization.INPlanningData;
import ScanType = Data.NDI.Enums.ScanType;
import IFieldGeom = Data.FieldManagement.IFieldGeom;
import ICampaignYear = Data.Authentication.ICampaignYear;
import {
  ApObjectHelper
}                                                                                          from '../../ap-core/utils/ap-object.helper';

@Component({
  selector: 'ap-n-fertilization-planning',
  template: `
    <ap-dyncomponent [loading$]="loading$"
                     [headerIcon]="'ap-icon-n-fertilization'"
                     [columns]="columns$ | async"
                     [fieldSets]="fieldSets$ | async"
                     [errorKeys]="errorKeys$ | async"
                     [canCreate]="false"
                     [canSearch]="true"
                     [items]="items$ | async"
                     [pager]="pager"
                     (edit)="onEdit($event)">
      <div class="ap-form-actions" dynforms.action>
        <div apResponsive
             [sizeMd]="'25-100'"
             [style.text-align]="'left'">
          <button kendoButton
                  [id]="'button_prev'"
                  [type]="'button'"
                  [class]="'button-important'"
                  (apSingleClick)="formPrevious.emit()">
            {{ 'Global_Back_With_Arrow' | translate }}
          </button>
        </div>
        <div apResponsive
             [sizeMd]="'50-100'"
             [style.text-align]="'center'">
          <ap-breadcrumbs-steper [columns]="breadCrumbsColumns"
                                 [selected]="1">
          </ap-breadcrumbs-steper>
        </div>
        <div apResponsive
             [sizeMd]="'25-100'"
             [style.text-align]="'right'">
          <button kendoButton
                  [id]="'button_next'"
                  [disabled]="nextDisabled$ | async"
                  [type]="'button'"
                  [themeColor]="'primary'"
                  [class]="'button-important'"
                  (apSingleClick)="formNext.emit()">
            {{ 'Global_Next_With_Arrow' | translate }}
          </button>
        </div>
      </div>
    </ap-dyncomponent>
    <ng-template #diagram>
      <!--ap-line-chart [data$]="chartData$"
                     [noteValues$]="noteValues$"
                     [maxY$]="maxY$"
                     [xAxisLabel]="'N__ChartTitleX'"
                     [yAxisLabel]="'N__ChartTitleY'">
      </ap-line-chart-->
    </ng-template>
  `,
  providers: [
    GeneralConfig,
    ApplicationMapConfig,
    ApplicationMapAbsoluteConfig,
    RapeFertilizationConfig,
    NFertilizationConfig,
    TargetRateConfig,
    BoniturConfig,
    UniformConfig,
    TargetMapPerPlanConfig,
    NFertilizationPlanningEntryService
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ApNFertilizationPlanningEntryComponent implements OnInit, AfterContentInit, OnDestroy, IEntryComponent {
  /**
   * Implements IEntryComponent
   */
  public Caption$: BehaviorSubject<string> = new BehaviorSubject('Nutrients__SelectFieldsTitle');
  @ViewChild(ApDynComponentComponent, {static: true}) public dynComponent: ApDynComponentComponent;
  @ViewChild('diagram', {static: false}) public diagramTemplateRef: TemplateRef<any>;

  @Input() public data: NPlanningEntryComponentData;
  errorKeys$ = new BehaviorSubject<string[]>([]);
  columns$: Observable<ApDynGridColumnConfigBase[]> = of([]);
  fieldSets$ = new BehaviorSubject<ApDynformsConfigFieldset[]>([]);
  items$ = new BehaviorSubject<any[]>(undefined);
  pager: ApDynGridPagerWizardConfig;
  chartData$: Observable<number[][]>;
  noteValues$: Observable<{ value: number, color?: string }[]>;
  breadCrumbsColumns = ['Global__Selection', 'Global__Details', 'Admin_Pages__Overview'];
  loading$: Observable<boolean>;
  canSave$ = new BehaviorSubject<boolean>(false);
  formNext = new EventEmitter<void>();
  formPrevious = new EventEmitter<void>();
  nextDisabled$ = new BehaviorSubject<boolean>(true);
  maxY$: Observable<number>;

  private _currentStep = ApBaseWizardSteps.Selection;
  private _onCancelSelection = new EventEmitter<void>();
  private _onNextSelection = new EventEmitter<void>();
  private _onBackOverview = new EventEmitter<void>();
  private _onSaveOverview = new EventEmitter<void>();
  private _statisticUpdateRequested = new EventEmitter<void>();
  private _selectedFields$ = new BehaviorSubject<INFertilizationPlanFieldToSelectGridItem[]>([]);
  private _operationModeAppSettings$ = new BehaviorSubject<IOperationModeAppSetting[]>([]);
  private _formValues = {};
  private _selectedFieldsInfo: SelectedFieldsInfo;
  private _previousSelectedFieldsInfo: SelectedFieldsInfo;
  private _ecStageMinMax: EcStageMinMax;
  private _operationModeAppSetting: IOperationModeAppSetting | undefined;
  private _nPlanBooks: INFertilizationPlanningPlanBookData[];
  private _subscriptions: Subscription[] = [];
  private _selectFieldSubscriptions: Subscription[] = [];
  private _formSubscriptions: Subscription[] = [];
  private _overviewSubscriptions: Subscription[] = [];

  constructor(private applicationModesStore: ApplModesStore,
              private campaignYearStore: CampaignYearStore,
              private cropRotationStore: CropRotationStore,
              private cropService: ApGetCropService,
              private cropTypeStore: CropTypeStore,
              private dateService: ApDateService,
              private fieldStore: FieldStore,
              private generalConfig: GeneralConfig,
              private formStore: FormStore,
              private languageStore: LanguageStore,
              private loginStore: LoginStore,
              private mapViewStore: MapViewStore,
              private modalDialogStore: ModalDialogStore,
              private notifyStore: NotifyStore,
              private nFertilizationStore: NFertilizationStore,
              private operationModesStore: OperationModesStore,
              private basicFertilisationSummariesStore: BasicFertilisationSummariesStore,
              private roundNumericService: GetRoundNumericService,
              private settingsStore: SettingsStore,
              private translationStore: TranslationStore,
              private unitStore: UnitsStore,
              private mapStore: MapStore,
              private routerStore: RouterStore,
              private nFertilizationService: NFertilizationService,
              private sensorStore: SensorStore,
              private statisticStore: StatisticStore,
              private scanService: ScanService,
              private fieldService: FieldService,
              private timeAreaService: TimeAreaService,
              private translationService: ApTranslationService,
              private tooltipContentService: ApTooltipContentService,
              private agriportConstantsService: AgriportConstantsService,
              private applicationSettingsService: ApplicationSettingsService,
              private nPlanningEntryService: NFertilizationPlanningEntryService,
              private nFertilizationCommonEntryService: NFertilizationCommonEntryService,
              private nFertilizationPlantProtectionService: NFertilizationPlantProtectionService,
              private timeFormatPipe: TimeFormatPipe,
              private roundNumericPipe: GetRoundNumericPipe,
              private applicationSettingsStore: ApplicationSettingsStore,
              private applicationMapAbsoluteConfig: ApplicationMapAbsoluteConfig,
              private uniformConfig: UniformConfig,
              private boniturConfig: BoniturConfig,
              private targetRateConfig: TargetRateConfig,
              private applicationMapConfig: ApplicationMapConfig,
              private nFertilizationConfig: NFertilizationConfig,
              private targetMapPerPlanConfig: TargetMapPerPlanConfig,
              private rapeFertilizationConfig: RapeFertilizationConfig,
              private croptypeService: CroptypeService) {
  }

  public ngOnInit(): void {
    // Disable the ability to navigate back in browser
    history.pushState(null, document.title, location.href);
    history.back();
    history.forward();
    window.addEventListener('popstate', this.preventGoBack);

    this.nPlanningEntryService.setComponentData(this.data);
    this.nPlanningEntryService.initData();
    this._gridBuilderSelectionGrid();
  }

  public ngAfterContentInit(): void {
    setTimeout(() => this.sensorStore.loadSensorFieldData());
    this._subscriptions.push(this.dynComponent.SelectedItems$.pipe(debounceTime(250)).subscribe(() => {
      this._statisticUpdateRequested?.emit();
    }));
    this._subscriptions.push(this.dynComponent.SelectedItems$.subscribe(() => {
      this._fieldSelection();
    }));
    this._subscriptions.push(
      combineLatest([
        this.dynComponent.gridSubject,
        this.Caption$,
      ]).pipe(
        filter(([grid, caption]) => !!grid && caption === 'Nutrients__SelectFieldsTitle')
      ).subscribe(([grid]) => {
        grid.gridPaging.setSelectedKeys(this.fieldStore.getSelectedFieldIds());
      })
    );
    this._subscriptions.push(this._onCancelSelection.subscribe(() => this._onCloseForm()));
    this._subscriptions.push(this._onNextSelection.subscribe(() => {
      this._currentStep = ApBaseWizardSteps.Details;
      this._selectFieldSubscriptions.forEach(x => x?.unsubscribe());
      const selectedFields = this.dynComponent.getSelectedItems() as INFertilizationPlanFieldToSelectGridItem[];
      const cropIds = [...new Set(selectedFields.map(x => x.CropId))];
      this._selectedFieldsInfo = {
        FieldIds: selectedFields.map(x => x.Id),
        CropTypes: this.cropTypeStore.getDefaultCroptype(cropIds[0]),
        EppoCode: selectedFields[0].EppoCode,
        HasAnyValidScan: selectedFields.some(x => x.ScanData.Status.state === ApColumnState.Green),
        IsRapeCrop: this.nFertilizationService.isRapeCrop(cropIds)
      };
      this._selectedFields$.next(selectedFields);
      this._formBuilderGeneral();
      this._selectFieldSubscriptions.forEach(x => x.unsubscribe());
      this.dynComponent.saveGridDescriptors('Selection');
    }));
    this._subscriptions.push(this.formPrevious.subscribe(() => {
      this._currentStep = ApBaseWizardSteps.Selection;
      this._formSubscriptions.forEach(x => x?.unsubscribe());
      this._gridBuilderSelectionGrid();
      this.dynComponent.loadGridDescriptors('Selection');
      this._formValues = ObjectFactory.Merge(ObjectFactory.Copy(this._formValues), this.dynComponent.getForm().value);
    }));
    this._subscriptions.push(this.formNext.subscribe(() => {
      this._currentStep = ApBaseWizardSteps.Overview;
      this._formSubscriptions.forEach(x => x?.unsubscribe());
      this._formValues = ObjectFactory.Merge(ObjectFactory.Copy(this._formValues), this.dynComponent.getForm().value);
      this._gridBuilderOverview();
      this.dynComponent.loadGridDescriptors('Overview');
    }));
    this._subscriptions.push(this._onBackOverview.subscribe(() => {
      this._currentStep = ApBaseWizardSteps.Details;
      this._overviewSubscriptions.forEach(x => x?.unsubscribe());
      this._clearMap();
      this._formBuilderGeneral();
      this.dynComponent.saveGridDescriptors('Overview');
      this.statisticStore.removeStatisticData();
    }));
    this._subscriptions.push(this._onSaveOverview.subscribe(() => {
      this._save();
      this._onCloseForm();
    }));
    this._subscriptions.push(this._statisticUpdateRequested.pipe(debounceTime(100)).subscribe(() => {
      this._generateStats();
    }));
    this._subscriptions.push(this.items$.subscribe(_ => this._statisticUpdateRequested.emit()));
    this._subscriptions.push(this.canSave$.subscribe(value => {
      this._canSaveCheck(value);
    }));
  }

  public ngOnDestroy(): void {
    window.removeEventListener('popstate', this.preventGoBack);
    this._subscriptions.forEach(s => s?.unsubscribe());
    this._selectFieldSubscriptions.forEach(x => x?.unsubscribe());
    this._formSubscriptions.forEach(x => x?.unsubscribe());
    this._overviewSubscriptions.forEach(x => x?.unsubscribe());
    this.statisticStore.removeStatisticData();
  }

  public onEdit(dataItem: any): void {
    dataItem = ObjectFactory.Copy(dataItem);
    const copiedFormValues = ObjectFactory.Copy(this._formValues);
    // to work around for our lovely <any> problem in n-fertilization,
    // the dataItem from the grid contains '-' text values for numeric columns
    // as it is passed to the form those strings cannot be parsed as number, and
    // this leads to a client error when editing a single row
    // ==> replace all '-' with undefined before passing it to the modalDialog
    for (const dataItemProperty of Object.keys(dataItem)) {
      if (dataItem[dataItemProperty] === '-') {
        dataItem[dataItemProperty] = undefined;
      }
    }
    this._updateDataForSingleEdit(copiedFormValues, dataItem);
    this.modalDialogStore.setModalDialogData({
      buttons: [
        {
          key: 'cancel',
          text: 'Global__Cancel',
          primary: false
        },
        {
          key: 'apply',
          text: 'Global__Ok',
          primary: true,
          disable: ModalDialogButtonDisable.FormInvalid,
        }
      ],
      show: true,
      title: this.translationStore.FindTranslationForSelectedLanguage('Docu_Ini__Edit'),
      formConfig: {
        fieldSets: this._getFieldSets(dataItem, copiedFormValues, this.modalDialogStore.listenChanges(),
          this._operationModeAppSetting),
        values: copiedFormValues
      },
      values: copiedFormValues
    } as IModalDialogData);
    const resultSubscription = this.modalDialogStore.Listen(s => s.result)
      .subscribe((result) => {
        if (result?.key === 'apply') {
          this._updateOverviewItems({ids: [dataItem['Id']], value: result.formValues});
          this._clearMap();
          resultSubscription.unsubscribe();
        } else if (result?.key === 'cancel' || result?.key === '') {
          resultSubscription.unsubscribe();
        }
      });
  }

  private _updateDataForSingleEdit(formValues: any, dataItem: any): void {
    const operationMode = this._operationModeAppSetting?.OperationMode;
    if (this.nFertilizationPlantProtectionService.isOperationModeAnyOfMaps(operationMode)
      || this.nFertilizationPlantProtectionService.isOperationModeAnyOfSensor(operationMode)) {
      formValues['Threshold'] = dataItem['Threshold'];
      formValues['Constant'] = dataItem['Constant'];

      // Maps should remain on the original Minimum and Maximum from a Details form step
      if (this.nFertilizationPlantProtectionService.isOperationModeAnyOfSensor(operationMode)) {
        formValues['Minimum'] = dataItem['Minimum'];
        formValues['Maximum'] = dataItem['Maximum'];
      }
    }
    if (operationMode !== OperationModesEnum.ApplicationMapAbsolute) {
      formValues['DeadBioMass'] = dataItem['DeadBioMass'];
      formValues['Amount'] = dataItem['Amount'];
    }
    if (operationMode === OperationModesEnum.Constant) {
      formValues['Constant'] = dataItem['Constant'];
      formValues['ProductAmountPerHa'] = dataItem['ProductAmountPerHa'];
      formValues['ProductAmount'] = dataItem['ProductAmount'];
    }
    formValues['ControlFactor'] = dataItem['ControlFactor'];
    formValues['Note'] = dataItem['Note'];
    formValues['ECStage'] = dataItem['ECStage'];
    formValues['Driver'] = dataItem['Driver'];
    formValues['Instrument'] = dataItem['Instrument'];
    formValues['Machine'] = dataItem['Machine'];
  }

  private _gridBuilderSelectionGrid(): void {
    this.Caption$.next('Nutrients__SelectFieldsTitle');
    this.fieldSets$.next([]);
    this.loading$ = combineLatest([
      this.fieldStore.Listen((s) => s.loading),
      this.cropRotationStore.Listen((s) => s.historyLoading),
      this.campaignYearStore.Listen((s) => s.loading),
      this.cropTypeStore.Listen((s) => s.loading),
      this.sensorStore.Listen((s) => s.loading),
      this.applicationSettingsStore.Loading$
    ]).pipe(
      map((loadings) => loadings.some(l => l))
    );
    this.columns$ = combineLatest([
      this.languageStore.SelectedLanguage$,
      this.settingsStore.FirstSetting$,
      this.campaignYearStore.SelectedCampaignYear$,
      this.cropRotationStore.History$
    ]).pipe(
      filter(([language, settings]) => !!language && !!settings),
      map(([language, setting, campaignYear, cropRotationHistory]) => [
        new ApDynGridStatusColumnConfig({
          field: nameOf<INFertilizationPlanFieldToSelectGridItem>('Status'),
          class: nameOf<INFertilizationPlanFieldToSelectGridItem>('StatusClass'),
          description: nameOf<INFertilizationPlanFieldToSelectGridItem>('StatusDesc'),
          filterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Docu_Ini__Number',
          field: nameOf<INFertilizationPlanFieldToSelectGridItem>('Nr'),
          width: 60,
          hide: true,
          filterable: true,
          filterType: FilterType.NUMBER,
          cssClass: 'right',
          headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Docu_Ini_Subnumber',
          field: nameOf<INFertilizationPlanFieldToSelectGridItem>('TNr'),
          width: 60,
          hide: true,
          filterable: true,
          filterType: FilterType.NUMBER,
          cssClass: 'right',
          headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Docu_Ini__Number',
          field: nameOf<INFertilizationPlanFieldToSelectGridItem>('NrTNr'),
          width: 70,
          filterable: true,
          headerFilterable: true,
          hide: new ApDynGridColumnHideConfig({
            selfHide: this.mapViewStore.Listen(s => s.mode).pipe(map((mode) => mode === MapViewMode.HIDE))
          })
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Docu_Ini__Name',
          field: nameOf<INFertilizationPlanFieldToSelectGridItem>('Name'),
          width: 180,
          filterable: true,
          sortIndex: 0,
          headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Docu_Ini__Area',
          field: nameOf<INFertilizationPlanFieldToSelectGridItem>('Area'),
          width: 60,
          filterable: true,
          headerFilterable: true,
          filterType: FilterType.NUMBER,
          cssClass: 'right',
          tooltip: (dataItem) => dataItem['Area'],
          pipes: [{
            pipe: this.roundNumericPipe,
            args: [setting.DigitsAfterDecimalPoint]
          }]
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__Crop',
          field: nameOf<INFertilizationPlanFieldToSelectGridItem>('Crop'),
          width: 100,
          filterable: true,
          headerFilterable: true,
          groupIndex: 0,
          cropColoring: true,
          groupDesc: true
        }),
        new ApDynGridStatusColumnConfig({
          field: `${nameOf<INFertilizationPlanFieldToSelectGridItem>('ScanData')}.${nameOf<BestScanData>('Status')}.${nameOf<IGridStatus>('state')}`,
          class: `${nameOf<INFertilizationPlanFieldToSelectGridItem>('ScanData')}.${nameOf<BestScanData>('Status')}.${nameOf<IGridStatus>('class')}`,
          description: `${nameOf<INFertilizationPlanFieldToSelectGridItem>('ScanData')}.${nameOf<BestScanData>('Status')}.${nameOf<IGridStatus>('description')}`,
          filterable: true,
          hide: new ApDynGridColumnHideConfig({
            selfHide: this.mapViewStore.Listen(s => s.mode).pipe(map((mode) => mode === MapViewMode.HIDE))
          })
        }),
        new ApDynGridGroupColumnConfig({
          title: 'Global__latest_Sensor_reading',
          hide: true,
          groupColumns: [
            new ApDynGridStatusColumnConfig({
              field: `${nameOf<INFertilizationPlanFieldToSelectGridItem>('ScanData')}.${nameOf<BestScanData>('Status')}.${nameOf<IGridStatus>('state')}`,
              class: `${nameOf<INFertilizationPlanFieldToSelectGridItem>('ScanData')}.${nameOf<BestScanData>('Status')}.${nameOf<IGridStatus>('class')}`,
              description: `${nameOf<INFertilizationPlanFieldToSelectGridItem>('ScanData')}.${nameOf<BestScanData>('Status')}.${nameOf<IGridStatus>('description')}`,
              filterable: true
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__EC',
              field: `${nameOf<INFertilizationPlanFieldToSelectGridItem>('ScanData')}.${nameOf<BestScanData>('Ec')}`,
              cssClass: 'right',
              filterType: FilterType.NUMBER,
              width: 40,
              filterable: true
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Date',
              field: `${nameOf<INFertilizationPlanFieldToSelectGridItem>('ScanData')}.${nameOf<BestScanData>('Created')}`,
              format: language.DateFormat,
              width: 80,
              filterable: true
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__AvgShort',
              field: `${nameOf<INFertilizationPlanFieldToSelectGridItem>('ScanData')}.${nameOf<BestScanData>('NUptakeAvg')}`,
              width: 60,
              cssClass: 'right',
              pipes: [{
                pipe: this.roundNumericPipe,
                args: [setting.DigitsAfterDecimalPoint, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
              }],
              filterType: FilterType.NUMBER,
              filterable: true
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Min',
              field: `${nameOf<INFertilizationPlanFieldToSelectGridItem>('ScanData')}.${nameOf<BestScanData>('NUptakeMin')}`,
              width: 60,
              filterable: true,
              cssClass: 'right',
              pipes: [{
                pipe: this.roundNumericPipe,
                args: [setting.DigitsAfterDecimalPoint, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
              }],
              filterType: FilterType.NUMBER,
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Max',
              field: `${nameOf<INFertilizationPlanFieldToSelectGridItem>('ScanData')}.${nameOf<BestScanData>('NUptakeMax')}`,
              width: 60,
              filterable: true,
              cssClass: 'right',
              pipes: [{
                pipe: this.roundNumericPipe,
                args: [setting.DigitsAfterDecimalPoint, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
              }],
              filterType: FilterType.NUMBER,
            }),
          ]
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Nutrients__Remaining',
          field: nameOf<INFertilizationPlanFieldToSelectGridItem>('Remaining'),
          width: 60,
          cssClass: 'right',
          filterType: FilterType.NUMBER,
          hide: true,
          pipes: [{
            pipe: this.roundNumericPipe,
            args: [setting.DigitsAfterDecimalPoint, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
          }]
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__Category',
          field: nameOf<INFertilizationPlanFieldToSelectGridItem>('CropCategory'),
          defaultFilter: this.croptypeService.getNonEcoSchemeCropCategoryTranslations(),
          width: 0,
          hide: true
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'IsSensorCrop',
          field: nameOf<INFertilizationPlanFieldToSelectGridItem>('IsSensorCrop'),
          defaultFilter: this.nFertilizationCommonEntryService.getDefaultFilterIsSensorCrop(this.data.ApplicationMode,
            this.data.PlanBooks, this._selectedFields$.getValue(), campaignYear, cropRotationHistory),
          width: 0,
          hide: true
        })
      ])
    );
    this.pager = new ApDynGridPagerWizardConfig(
      new ApDynGridPagerWizardButton('Global__Cancel', this._onCancelSelection),
      new ApDynGridPagerWizardBreadcrumbsStepper(
        ['Global__Selection', 'Global__Details', 'Admin_Pages__Overview'], 0),
      new ApDynGridPagerWizardButton('Global_Next_With_Arrow', this._onNextSelection, {
        active: this._activeItems(),
        primary: true
      })
    );
    this._selectFieldSubscriptions.push(
      combineLatest([
        this.loading$,
        this._activeItems()
      ]).pipe(
        filter(([loading, _]) => !loading),
        debounceTime(100)
      ).subscribe(([_, active]) => {
        const selectedItems = (this.dynComponent.getSelectedItems() as INFertilizationPlanFieldToSelectGridItem[]) ?? [];
        this.errorKeys$.next(active ? [] : selectedItems.map((item) => item.Id.toString()));
        if (!active && selectedItems.length > 0
          && !this.notifyStore.getNotify().some(x => x.ErrorKey === 'Global__Various_Crop_Selected')) {
          this.notifyStore.addMessage({
            Level: ApValidationLevel.Error,
            Counter: 1,
            ErrorKey: 'Global__Various_Crop_Selected',
            UserId: null,
            UserName: null,
            DisplayTimeout: 2,
            Parameters: null
          });
        }
      })
    );
    this._selectFieldSubscriptions.push(
      combineLatest([
        this.fieldStore.Fields$,
        this.cropRotationStore.Listen(s => s.history),
        this.campaignYearStore.Listen(s => s.selectedYear),
        this.cropTypeStore.Listen(s => s.cropTypesNames),
        this.nFertilizationStore.GetNeeds$(this.campaignYearStore.getSelectedCampaignYear()?.Year),
        this.sensorStore.Listen(s => s.data),
        this.nFertilizationStore.Listen(x => x.planBooks),
        this.nFertilizationStore.Listen(x => x.logfiles),
        this.basicFertilisationSummariesStore.Summaries$,
        this.applicationSettingsStore.Applications$
      ]).pipe(
        filter(([fields, cropRotation]) => fields.length !== 0 && Object.keys(cropRotation).length !== 0),
        map(([fields, cropRotation, year, cropTypes, needs, sensorFieldData, planBooks, logFiles, bfSummaries, _]) => fields.map((field) => {
          const geom = this.fieldStore.getCurrentFieldGeom(field);
          const sensorData = sensorFieldData?.Find(x => x?.FieldGeomId === geom?.Id) as ISensorFieldData;
          const cropId = this.nFertilizationCommonEntryService.getCropTypeId(field.Id, year, cropRotation);
          const cropType = this.cropTypeStore.getDefaultCroptype(cropId);
          const cropTypeName = cropTypes?.[cropId];
          const status = this._getStatus(geom, year, sensorData, cropType);
          const needValue = needs.Find((need) => need.FieldId === field.Id)?.Value ?? null;
          const baseFertPlanBooks = bfSummaries.map(x => x.BasicFertilisationPlanBooks).flat();
          const alreadyApplied = this.nFertilizationService.calculateAlreadyAppliedFromContentNPlanBooks(field, planBooks, logFiles, baseFertPlanBooks);
          const bestScanData = this.scanService.getBestScanData(field, this.getDefaultBestScanStatus());
          return {
            Id: field.Id,
            Status: status.state,
            StatusClass: status.class,
            StatusDesc: status.description,
            Nr: field.FieldNumber,
            TNr: field.FieldSubnumber,
            NrTNr: this.fieldStore.getFieldNumberAndSubNumber(field),
            Name: field.FieldName,
            Area: geom ? geom.AreaHa : undefined,
            Crop: cropTypeName,
            CropId: cropId,
            EppoCode: cropType?.Eppocode,
            SecondCropId: (this.cropService.getCrop(field, false, 'object') as ICropTypes)?.Id,
            Geom: geom,
            Kind: null,
            Application: null,
            FieldCropEc: this.cropService.getFieldCrop(field)?.EcValue ?? undefined,
            Sum: null,
            DBW: needValue,
            NUptake: null,
            PlanBookId: bestScanData?.PlanId ?? ApGuidUtil.getEmptyGuid(),
            Remaining: this.nFertilizationService.calculateRemainingValue(alreadyApplied, needValue) ?? '-',
            ScanData: bestScanData,
            CropCategory: this.translationService.translate(this.croptypeService.getCropCategoryForCurrentCampaignYear(field)),
            IsSensorCrop: cropType?.IsSensorCrop ?? false,
          } as INFertilizationPlanFieldToSelectGridItem;
        })),
      ).subscribe((items) => this.items$.next(items))
    );
  }

  private _formBuilderGeneral(): void {
    this.Caption$.next('Global__Details');
    this.columns$ = of([]);
    this.selectedFieldsDataChanged();
    this.onDetailsFormGeneration();
    this.maxY$ = this.dynComponent.FormValues$.pipe(
      distinctUntilChanged((previous, current) =>
        current['Maximum'] === previous['Maximum'] &&
        current['ControlRange'] === previous['ControlRange'] &&
        current['TargetRate'] === previous['TargetRate']),
      map((v) => {
        const operationMode = this._operationModeAppSettings$.getValue().FirstOrDefault(x => x.Id === v['OperationMode'])?.OperationMode;
        return operationMode === OperationModesEnum.ApplicationMap ? v['ControlRange'] + v['TargetRate'] : v['Maximum'];
      })
    );
    this.chartData$ = this.dynComponent.FormValues$.pipe(
      map((values) => {
        const valuesOperationMode = this._operationModeAppSettings$.getValue().FirstOrDefault(x => x.Id === values['OperationMode'])?.OperationMode;
        return ({
          amount: values['Amount'] !== '' ? values['Amount'] : undefined,
          threshold: values['Threshold'] !== '' ? values['Threshold'] : undefined,
          min: values['Minimum'] !== '' ? values['Minimum'] : undefined,
          max: values['Maximum'] !== '' ? values['Maximum'] : undefined,
          factor: values['ControlFactor'] !== '' ? values['ControlFactor'] : undefined,
          targetRate: values['TargetRate'] !== '' ? values['TargetRate'] : undefined,
          controlRange: values['ControlRange'] !== '' ? values['ControlRange'] : undefined,
          referenceValue: values['ReferenceValue'] !== '' ? values['ReferenceValue'] : undefined,
          operationMode: valuesOperationMode != null ? valuesOperationMode : undefined
        });
      }),
      distinctUntilChanged((x, y) => JSON.stringify(x) === JSON.stringify(y)),
      map((values) => {
        const avgNUptake =
          this._selectedFields$.getValue().reduce((res, f) => res + f.NUptake, 0)
          / this._selectedFields$.getValue().length;
        if (this.nFertilizationCommonEntryService.isOperationModeGroupMapButNotConst(values.operationMode)) {
          return CurveCreator.createCurve(
            avgNUptake, values.amount, values.threshold, values.min, values.max, values.factor);
        } else if (values.operationMode === OperationModesEnum.TargetValue) {
          const min = values.targetRate - values.controlRange;
          const max = values.targetRate + values.controlRange;
          return CurveCreator.createCurve(
            avgNUptake, values.targetRate, values.threshold * avgNUptake / 100, min, max, values.factor);
        } else if (values.operationMode === OperationModesEnum.NFertilization) {
          return CurveCreator.createCurve(
            18, values.amount, 6, values.min, values.max, values.factor);
        }
        return undefined;
      }),
    );
    this.noteValues$ = this.dynComponent.FormValues$.pipe(
      map((values) => {
        const valuesOperationMode = this._operationModeAppSettings$.getValue().FirstOrDefault(x => x.Id === values['OperationMode'])?.OperationMode;
        return ({
          threshold: values['Threshold'] !== '' ? values['Threshold'] : undefined,
          operationMode: valuesOperationMode != null ? valuesOperationMode : undefined
        });
      }),
      distinctUntilChanged((x, y) => JSON.stringify(x) === JSON.stringify(y)),
      map((values) => {
        const avgNUptake =
          this._selectedFields$.getValue().reduce((res, f) => res + f.NUptake, 0)
          / this._selectedFields$.getValue().length;
        if (values.operationMode === OperationModesEnum.TargetValue) {
          values.threshold *= avgNUptake / 100;
        } else if (values.operationMode === OperationModesEnum.NFertilization) {
          return CurveCreator.createNotes(18, values.threshold ? 6 : undefined);
        }
        return CurveCreator.createNotes(avgNUptake, values.threshold);
      }),
    );
    this._formSubscriptions.push(
      this.dynComponent.FormValues$.pipe(
        distinctUntilChanged((previous, current) => previous['Group'] === current['Group']),
      ).subscribe(() => {
        const product = this.dynComponent?.getForm()?.get('Product');
        if (product) {
          product.setValue(undefined);
        }
      })
    );
    this._formSubscriptions.push(
      combineLatest([
        this.dynComponent.Valid$,
        this.fieldSets$
      ]).pipe(
        filter(([, fs]) => fs.length !== 0),
        debounceTime(10),
        delay(1),
        map(([v]) => !v)
      ).subscribe((disable) => {
          this.dynComponent.dynForm.form.markAllAsTouched();
          this.nextDisabled$.next(disable);
        }
      )
    );
    this._formSubscriptions.push(
      this.dynComponent.FormValues$.asObservable().pipe(
        filter(() => this.data.ApplicationMode === ApplicationModesEnum.Variable),
        tap(values => {
          if ('OperationMode' in values) {
            values['OperationMode'] ??= undefined;
          }
          if ('ECStage' in values) {
            values['ECStage'] ??= undefined;
          }
        }),
        startWith({} as any),
        pairwise(),
        filter(([previous, current]) => {
          if (Object.keys(previous).length === 0 || Object.keys(current).length === 0) {
            return false;
          }
          let isModeTheSameAsBefore = previous['OperationMode'] === current['OperationMode'];
          if (previous['ECStage'] !== current['ECStage']) {
            const currentEcStage = current['ECStage'];
            if (!Number.isFinite(currentEcStage) || currentEcStage < this._ecStageMinMax.Min
              || currentEcStage > this._ecStageMinMax.Max) {
              // Keep the operation mode unchanged when ECStage is out of range
              isModeTheSameAsBefore = true;
            } else {
              // Recalculate available operation modes for the new ECStage
              const operationModes = this.getOperationModeAppSettings(this.data.ApplicationMode,
                this._selectedFieldsInfo.EppoCode, currentEcStage, this._selectedFieldsInfo.IsRapeCrop,
                this._selectedFieldsInfo.HasAnyValidScan);
              this._operationModeAppSettings$.next(operationModes);
              // Check if the current operation mode is still valid
              const hasNoOperationMode = !current['OperationMode'];
              const hasNoAvailableModes = operationModes.length === 0;
              const isCurrentModeStillValid = operationModes.some(x => x.Id === current['OperationMode']);
              isModeTheSameAsBefore = (hasNoOperationMode && hasNoAvailableModes) || isCurrentModeStillValid;
            }
          }
          return !isModeTheSameAsBefore;
        }),
        map(([, current]) => current),
        tap(values => {
          const operationModeId = values['OperationMode'] as string;
          const operationModeAppSettings = this._operationModeAppSettings$.getValue();
          this._operationModeAppSetting = operationModeAppSettings.find(x => x.Id === operationModeId)
            ?? this.nPlanningEntryService.selectedDefaultOperationMode(this.data.ApplicationMode,
              this._selectedFieldsInfo.IsRapeCrop, operationModeAppSettings);
          this._cleanUpFormValues(values);
          values['OperationMode'] = this._operationModeAppSetting?.Id;
          this._formValues = ObjectFactory.Copy(values);
        }),
        map(() => this._createForm(this._operationModeAppSetting))
      ).subscribe(fieldSets => {
        this.fieldSets$.next(fieldSets);
        setTimeout(() => this.dynComponent.dynForm.markAsTouched());
      })
    );
    this.fieldSets$.next(
      this._createForm(this._operationModeAppSetting)
    );
    this._statisticUpdateRequested.emit();
  }

  private _gridBuilderOverview(): void {
    const operationMode = this._operationModeAppSetting.OperationMode;
    const isApplicationMap = this.nFertilizationPlantProtectionService.isOperationModeAnyOfMapsOrConstant(operationMode);
    this.fieldSets$.next([]);
    this.Caption$.next('Admin_Pages__Overview');
    this.nFertilizationStore.clearNPlanningStatistic();
    this._createGridDataObjects(isApplicationMap);
    this._initializeGridOverviewItem(isApplicationMap, true);
    this._gridBuilderOverviewColumns(isApplicationMap);
    if (isApplicationMap) {
      this._createNPlanningJob();
    }
    this._statisticUpdateRequested.emit();
  }

  private _activeItems(): Observable<boolean> {
    return this.dynComponent.SelectedItems$.pipe(
      delay(1),
      map((items: INFertilizationPlanFieldToSelectGridItem[]) => {
        if (this.data.ApplicationMode === ApplicationModesEnum.Constant) {
          return items.length !== 0;
        }
        return items.length !== 0 &&
          items.every(_ => _?.Status >= 0) &&
          items.every((i) => i.EppoCode === items[0].EppoCode);
      })
    );
  }

  private selectedFieldsDataChanged(): void {
    if (!!this._previousSelectedFieldsInfo) {
      if (!ObjectFactory.Equal(this._previousSelectedFieldsInfo, this._selectedFieldsInfo)) {
        this._formValues['Machine'] = undefined;
        this._formValues['Driver'] = undefined;
        this._formValues['Group'] = undefined;
        this._formValues['Instrument'] = undefined;
        this._formValues['OperationMode'] = undefined;
        this._formValues['ECStage'] = undefined;
        this._cleanUpFormValues(this._formValues);
      }
    }
    this._previousSelectedFieldsInfo = ObjectFactory.Copy(this._selectedFieldsInfo);
  }

  private _cleanUpFormValues(formValues: any): void {
    formValues['Amount'] = undefined;
    formValues['Threshold'] = undefined;
    formValues['DeadBioMass'] = undefined;
    formValues['Minimum'] = undefined;
    formValues['Maximum'] = undefined;
    formValues['Product'] = undefined;
    formValues['Constant'] = undefined;
    formValues['ControlFactor'] = undefined;
    formValues['TargetRate'] = undefined;
    formValues['ControlRange'] = undefined;
    formValues['ReferenceValue'] = undefined;
  }

  private _gridBuilderOverviewColumns(isApplicationMap: boolean): void {
    if (isApplicationMap) {
      this._overviewSubscriptions.push(this.items$
        .pipe(debounceTime(10))
        .subscribe((items) => this.canSave$.next((items.every((i) => !i['ColumnLoading'] && !i['ErrorMessage']))))
      );
    } else {
      this.canSave$.next(true);
    }

    this.pager = new ApDynGridPagerWizardConfig(
      new ApDynGridPagerWizardButton('Global_Back_With_Arrow', this._onBackOverview),
      new ApDynGridPagerWizardBreadcrumbsStepper(['Global__Selection', 'Global__Details', 'Admin_Pages__Overview'], 2),
      new ApDynGridPagerWizardButton('Global__Save', this._onSaveOverview, {
        active: this.canSave$,
        id: 'button_save',
        primary: true
      })
    );

    this.columns$ = combineLatest([
      this.languageStore.SelectedLanguage$,
      this.settingsStore.FirstSetting$
    ]).pipe(
      filter(([language, setting]) => !!language && !!setting),
      map(([language, setting]) => {
        const mapHide = this.mapViewStore.Listen(s => s.mode).pipe(
          map((mapMode) => mapMode === MapViewMode.HIDE));
        let result: ApDynGridColumnConfigBase[] = [
          new ApDynGridStatusColumnConfig({
            field: `Status.${nameOf<IGridStatus>('state')}`,
            class: `Status.${nameOf<IGridStatus>('class')}`,
            description: `Status.${nameOf<IGridStatus>('description')}`,
            filterable: true
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Docu_Ini__Number',
            field: 'Nr',
            width: 60,
            hide: true,
            filterType: FilterType.NUMBER,
            cssClass: 'right',
            headerFilterable: true
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Docu_Ini_Subnumber',
            field: 'TNr',
            width: 60,
            hide: true,
            filterType: FilterType.NUMBER,
            cssClass: 'right',
            headerFilterable: true
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Docu_Ini__Number',
            field: 'NrTNr',
            width: 70,
            headerFilterable: true,
            hide: new ApDynGridColumnHideConfig({
              selfHide: mapHide
            })
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Docu_Ini__Name',
            field: 'Name',
            width: 150,
            cssClass: 'left',
            sortIndex: 0,
            headerFilterable: true
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Docu_Ini__Area',
            field: 'Area',
            width: 60,
            headerFilterable: true,
            tooltip: (dataItem) => dataItem['Area'],
            cssClass: 'right',
            filterType: FilterType.NUMBER,
            pipes: [{
              pipe: this.roundNumericPipe,
              args: [setting.DigitsAfterDecimalPoint]
            }]
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Global__Crop',
            field: 'Crop',
            width: 80,
            hide: true,
            cropColoring: true,
            headerFilterable: true
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Global__EC',
            field: 'ECStage',
            width: 50,
            hide: true,
            cssClass: 'right',
            filterType: FilterType.NUMBER,
          })
        ];
        const appSettingsParameters = this._operationModeAppSetting?.ApplicationSetting?.Parameter;
        switch (this._operationModeAppSetting?.OperationMode) {
          case OperationModesEnum.ApplicationMap:
            result = result.concat(this.applicationMapConfig.gridBuilderConfig(mapHide, appSettingsParameters));
            break;
          case OperationModesEnum.ApplicationMapAbsolute:
            result = result.concat(this.applicationMapAbsoluteConfig.gridBuilderConfig(mapHide, appSettingsParameters));
            break;
          case OperationModesEnum.NfTargetMapPerPlan:
            result = result.concat(this.targetMapPerPlanConfig.gridBuilderConfig(mapHide, appSettingsParameters));
            break;
          case OperationModesEnum.TargetValue:
            result = result.concat(this.targetRateConfig.gridBuilderConfig());
            break;
          case OperationModesEnum.NFertilization:
            result = result.concat(this.nFertilizationConfig.gridBuilderConfig());
            break;
          case OperationModesEnum.RapeFertilization:
            result = result.concat(this.rapeFertilizationConfig.gridBuilderConfig());
            break;
          case OperationModesEnum.Constant:
            result = result.concat(this.uniformConfig.gridBuilderConfig(this._formValues['Product']));
            break;
        }
        result = result.concat([
          new ApDynGridPropertyColumnConfig({
            title: 'Base__SortItemDate',
            field: 'Date',
            format: language.DateFormat,
            hide: true,
            width: 90
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Nutrients__Remaining',
            field: 'Remaining',
            width: 90,
            hide: true,
            cssClass: 'right',
            filterType: FilterType.NUMBER,
            pipes: [{
              pipe: this.roundNumericPipe,
              args: [this.settingsStore.FirstSetting.DigitsAfterDecimalPoint, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
            }]
          }),
          new ApDynGridGroupColumnConfig({
            title: 'Settings__Lbl_Menu_Resources',
            hide: true,
            groupColumns: [
              new ApDynGridPropertyColumnConfig({
                field: 'DurationInMilliseconds',
                title: `${this.translationService.translate('TotalTime')} [${this.translationService.translate('Base__UnitH')}]`,
                hide: true,
                width: 70,
                cssClass: 'right',
                headerFilterable: true,
                tooltip: (dataItem: any) => this.tooltipContentService.getCapacityPerformanceTooltip(dataItem?.HaPerHour),
                pipes: [{
                  pipe: this.timeFormatPipe,
                  args: [{
                    formatType: FormatType.Decimals,
                    suffixValue: 'Base__UnitH',
                    decimalsFormatOptions: {
                      decimalsCount: 1,
                      decimalsSeparator: language.DecimalSeperator
                    }
                  }]
                }]
              }),
              new ApDynGridPropertyColumnConfig({
                field: 'Machine.NameWithSign',
                title: 'Base__Engine',
                width: 100,
                hide: true,
              }),
              new ApDynGridPropertyColumnConfig({
                field: 'Instrument.Name',
                title: 'AgriConnect_Ini__Tool',
                width: 100,
                hide: true
              }),
              new ApDynGridPropertyColumnConfig({
                field: 'Driver.FirstNameFullName',
                title: 'Docu_Ini__Motorist',
                width: 100,
                hide: true
              })
            ]
          }),
          new ApDynGridEditColumnConfig({})
        ]);
        return result;
      })
    );
  }

  private _initializeGridOverviewItem(isApplicationMap: boolean, initializeSubscription: boolean): void {
    const nNeeds = this.nFertilizationStore.GetNeeds(this.campaignYearStore.getSelectedCampaignYear().Year);
    const planBooks = this.nFertilizationStore.Listen(x => x.planBooks).getValue();
    const logFiles = this.nFertilizationStore.Listen(x => x.logfiles).getValue();
    const bfPlanBooks = this.basicFertilisationSummariesStore.Summaries.map(x => x.BasicFertilisationPlanBooks).flat();
    if (isApplicationMap && initializeSubscription) {
      this._overviewSubscriptions.push(
        combineLatest([
          this.nFertilizationStore.Listen(s => s.fieldNPlanningStatistic),
          this._selectedFields$,
        ]).subscribe(([fieldNPlanningStatistic, fields]) => {
          this.items$.next(fields.map((field) => {
            const planBook = this._getNPlanningPlanBookData(field.Geom?.Id);
            const needValue = nNeeds.find((need) => need.FieldId === field.Id)?.Value;
            const fieldFromStore = this.fieldStore.getFieldById(field.Id);
            let alreadyApplied = this.nFertilizationService.calculateAlreadyAppliedFromContentNPlanBooks(
              fieldFromStore, planBooks, logFiles, bfPlanBooks);
            const statistic = fieldNPlanningStatistic?.filter(x => x.FieldGeomId === field.Geom.Id) ?? [];
            if (statistic && statistic.length > 0) {
              planBook.ColumnLoading = false;
              if (statistic[0].ErrorText !== null) {
                planBook.HasError = true;
                planBook.ErrorMessage = statistic[0].ErrorText;
              } else {
                planBook.HasError = false;
                planBook.ErrorMessage = '';
                planBook.Amount = this.roundNumericService.roundAsNumber(statistic[0].Mean);
                planBook.Minimum = this.roundNumericService.roundAsNumber(statistic[0].Min);
                planBook.Maximum = this.roundNumericService.roundAsNumber(statistic[0].Max);
                planBook.PlanId = statistic[0].PlanId;
                if (this._isRemainingValueCouldBeApplied(planBook.OperationModeKey)) {
                  alreadyApplied += this.nFertilizationService.getAlreadyApplied(statistic[0].Mean, planBook.ProductId);
                }
              }
            }
            return {
              ...field,
              Id: field.Id,
              Status: this.nFertilizationPlantProtectionService.getStatusForItemOnOverviewStep(planBook.OperationModeKey as OperationModesEnum),
              PlanId: planBook.PlanId,
              OperationMode: planBook.OperationModeKey,
              ApplicationMode: planBook.ApplicationModeKey,
              ErrorMessage: planBook.HasError ? planBook.ErrorMessage : '',
              AvgAmount: planBook.AvgAmount,
              ProductId: planBook.ProductId,
              Threshold: planBook.HasError ? '-' : planBook.Threshold,
              ThresholdAbs: planBook.HasError ? '-' : planBook.ThresholdAbs,
              Constant: planBook.HasError ? '-' : planBook.Constant,
              Minimum: planBook.HasError ? '-' : planBook.Minimum,
              Maximum: planBook.HasError ? '-' : planBook.Maximum,
              Amount: planBook.HasError ? '-' : planBook.Amount,
              ControlFactor: planBook.HasError ? '-' : planBook.ControlFactor,
              ControlFactorDescription: planBook.ControlFactorDescription,
              ECStage: planBook.ECStage,
              TargetRate: planBook.TargetRate,
              ControlRange: planBook.ControlRange,
              ReferenceValue: planBook.ReferenceValue,
              DeadBioMass: planBook.DeadBioMass,
              Driver: planBook.Driver,
              Machine: planBook.Machine,
              Instrument: planBook.Instrument,
              DurationInMilliseconds: planBook.DurationInMilliseconds,
              HaPerHour: planBook.HaPerHour,
              Date: planBook.FertilizationDate,
              ProductAmount: planBook.ProductAmount,
              ProductAmountPerHa: planBook.ProductAmountPerHa,
              Remaining: this.nFertilizationService.calculateRemainingValue(alreadyApplied, needValue ?? null),
              ColumnLoading: planBook.ColumnLoading,
              AvgNUptake: planBook.ScanData.NUptakeAvg
            };
          }));
        })
      );
    } else {
      const selectedFields = this._selectedFields$.getValue();
      this.items$.next(selectedFields.map((field) => {
        const planBook = this._getNPlanningPlanBookData(field.Geom?.Id);
        const needValue = nNeeds.find((need) => need.FieldId === field.Id)?.Value;
        const fieldFromStore = this.fieldStore.getFieldById(field.Id);
        let alreadyApplied = this.nFertilizationService.calculateAlreadyAppliedFromContentNPlanBooks(
          fieldFromStore, planBooks, logFiles, bfPlanBooks);
        if (this._isRemainingValueCouldBeApplied(planBook.OperationModeKey)) {
          alreadyApplied += this.nFertilizationService.getAlreadyApplied(planBook.Constant, planBook.ProductId);
        }
        return {
          ...field,
          Id: field.Id,
          Status: this.nFertilizationPlantProtectionService.getStatusForItemOnOverviewStep(planBook.OperationModeKey as OperationModesEnum),
          ErrorMessage: '',
          PlanId: planBook.PlanId,
          OperationMode: planBook.OperationModeKey,
          ApplicationMode: planBook.ApplicationModeKey,
          AvgAmount: planBook.AvgAmount,
          ProductId: planBook.ProductId,
          Threshold: planBook.Threshold,
          ThresholdAbs: planBook.ThresholdAbs,
          ControlFactor: planBook.ControlFactor,
          ControlFactorDescription: this.translationStore.FindTranslationForSelectedLanguage(planBook.ControlFactorDescription),
          Constant: planBook.Constant,
          Minimum: planBook.ControlRange ? planBook.TargetRate - planBook.ControlRange : planBook.Minimum,
          Maximum: planBook.ControlRange ? planBook.TargetRate + planBook.ControlRange : planBook.Maximum,
          ECStage: planBook.ECStage,
          TargetRate: planBook.TargetRate,
          ControlRange: planBook.ControlRange,
          ReferenceValue: planBook.ReferenceValue,
          Amount: planBook.Amount,
          DeadBioMass: planBook.DeadBioMass,
          Driver: planBook.Driver,
          Machine: planBook.Machine,
          Instrument: planBook.Instrument,
          DurationInMilliseconds: planBook.DurationInMilliseconds,
          HaPerHour: planBook.HaPerHour,
          Date: planBook.FertilizationDate,
          ProductAmount: planBook.ProductAmount,
          ProductAmountPerHa: planBook.ProductAmountPerHa,
          Remaining: this.nFertilizationService.calculateRemainingValue(alreadyApplied, needValue ?? null),
          ColumnLoading: false,
          AvgNUptake: 0
        };
      }));
    }
  }

  private _getNPlanningPlanBookData(fieldGeomId: IGuid): INFertilizationPlanningPlanBookData {
    return this._nPlanBooks.Find(_ => _.FieldGeomId === fieldGeomId);
  }

  private _createGridDataObjects(isApplicationMap: boolean): void {
    this._nPlanBooks = [];
    const selectedFields = this._selectedFields$.getValue();
    selectedFields.map((field) => {
      const operationModeFromForm = this._operationModeAppSetting?.OperationMode;
      const applicationModeFromForm = this.data.ApplicationMode;
      const fieldScanData = {FieldStatus: field.Status, ScanData: field.ScanData} as FieldScanData;
      const operationModeKey = this.nFertilizationPlantProtectionService.getOperationModeForPlan(
        operationModeFromForm, fieldScanData, this._operationModeAppSetting?.ApplicationSetting);
      const applicationModeKey = this.nFertilizationPlantProtectionService.getApplicationModeForPlan(
        operationModeKey, applicationModeFromForm, fieldScanData);
      const slope = this.nFertilizationPlantProtectionService.getSlope(operationModeKey, this._formValues['ControlFactor'],
        this._selectedFieldsInfo.IsRapeCrop, this._operationModeAppSetting?.ApplicationSetting);
      const controlFactorDescription = this.nFertilizationPlantProtectionService.getControlFactorDescription(operationModeKey,
        slope, this._operationModeAppSetting?.ApplicationSetting, false);
      const duration = this.timeAreaService.getTotalDurationInMilliseconds(field?.Geom?.AreaHa,
        this._formValues['HaPerHour']);
      const nPlanBook = {
        PlanId: isApplicationMap ? ApGuidUtil.generateNewGuid() : ApGuidUtil.getEmptyGuid(),
        FieldGeomId: field?.Geom?.Id,
        FieldId: field.Id,
        OperationModeKey: operationModeKey,
        ApplicationModeKey: applicationModeKey,
        ControlFactor: slope,
        DurationInMilliseconds: duration,
        ControlFactorDescription: controlFactorDescription,
        ScanData: field.ScanData,
        ProductId: !this._formValues['Product'] ? 0 : this._formValues['Product'],
        CropTypeMapId: this.cropTypeStore.getCropTypeMapId(field.CropId),
        Minimum: this._formValues['Minimum'],
        Maximum: this._formValues['Maximum'],
        Threshold: this._formValues['Threshold'],
        Amount: this._formValues['Amount'],
        AvgAmount: this._formValues['AvgAmount'],
        ECStage: this._formValues['ECStage'],
        Constant: this._formValues['Constant'],
        DeadBioMass: this._formValues['DeadBioMass'],
        TargetRate: this._formValues['TargetRate'],
        ControlRange: this._formValues['ControlRange'],
        ReferenceValue: this._formValues['ReferenceValue'],
        Driver: this._formValues['Driver'],
        Machine: this._formValues['Machine'],
        Instrument: this._formValues['Instrument'],
        HaPerHour: this._formValues['HaPerHour'],
        FertilizationDate: this._formValues['FertilizationDate'],
        ProductAmount: this._formValues['ProductAmount'],
        ProductAmountPerHa: this._formValues['ProductAmountPerHa'],
        ColumnLoading: true,
        HasError: false,
        Note: '',
        ErrorMessage: '',
        ThresholdAbs: undefined,
        JobNUptake: undefined
      } as INFertilizationPlanningPlanBookData;
      if (nPlanBook.OperationModeKey === OperationModesEnum.ApplicationMap) {
        nPlanBook.JobNUptake = field.ScanData.NUptakeAvg;
        nPlanBook.ThresholdAbs = nPlanBook.JobNUptake * (nPlanBook.Threshold / 100);
      }
      if (nPlanBook.OperationModeKey === OperationModesEnum.ApplicationMapAbsolute) {
        nPlanBook.JobNUptake = 0;
      }
      if (nPlanBook.OperationModeKey === OperationModesEnum.NfTargetMapPerPlan) {
        nPlanBook.JobNUptake = this.nFertilizationPlantProtectionService.calculateAreaWeightedAverageOfScans(
          selectedFields, this._operationModeAppSetting?.ApplicationSetting);
        nPlanBook.ThresholdAbs = nPlanBook.JobNUptake * (nPlanBook.Threshold / 100);
      }
      if (nPlanBook.OperationModeKey === OperationModesEnum.TargetValue) {
        nPlanBook.Minimum = nPlanBook.TargetRate - nPlanBook.ControlRange;
        nPlanBook.Maximum = nPlanBook.TargetRate + nPlanBook.ControlRange;
        nPlanBook.Constant = nPlanBook.TargetRate;
      }
      this._nPlanBooks.Add(nPlanBook);
    });
  }

  private _createForm(operationModeAppSetting: IOperationModeAppSetting | undefined): ApDynformsConfigFieldset[] {
    const isFieldsForModal = false;
    const isFormInitializedBefore = this.fieldSets$.getValue().length > 0;
    const copiedFormValues = ObjectFactory.Copy(this._formValues);
    const selectedFields = this._selectedFields$.getValue();
    const cropKey = this._selectedFieldsInfo.CropTypes?.CropKey;
    const applicationSettings = operationModeAppSetting?.ApplicationSetting;
    const fromValues$ = this.dynComponent.FormValues$.pipe(delay(0));
    const avgNMin = this.nFertilizationCommonEntryService.getAverageMinFromScans(selectedFields);
    const fieldSets = this.generalConfig.getInfoFieldSets(this.dynComponent.dynForm, copiedFormValues,
      operationModeAppSetting, this._operationModeAppSettings$.asObservable(), this._ecStageMinMax, selectedFields);
    if (operationModeAppSetting?.OperationMode !== OperationModesEnum.Bonitur) {
      fieldSets.push(this.generalConfig.getProductFieldSet(copiedFormValues, this.dynComponent.FormValues$));
    }
    if (operationModeAppSetting?.ApplicationMode === ApplicationModesEnum.Variable) {
      if (this.nFertilizationPlantProtectionService.isOperationModeAnyOfMaps(operationModeAppSetting.OperationMode)) {
        this.nFertilizationPlantProtectionService.onApplicationSettingsTextWarning(
          selectedFields.map(x => ({FieldStatus: x.Status, ScanData: x.ScanData})),
          applicationSettings);
      }
      switch (operationModeAppSetting.OperationMode) {
        case OperationModesEnum.ApplicationMap:
          this.applicationMapConfig.updateFormValuesByParameters(copiedFormValues, selectedFields, applicationSettings);
          fieldSets.push(
            ...this.applicationMapConfig.formBuilder(copiedFormValues, fromValues$, applicationSettings, isFieldsForModal,
              isFormInitializedBefore, this.diagramTemplateRef)
          );
          break;
        case OperationModesEnum.ApplicationMapAbsolute:
          this.applicationMapAbsoluteConfig.updateFormValuesByParameters(copiedFormValues, selectedFields, cropKey, avgNMin,
            applicationSettings);
          fieldSets.push(
            ...this.applicationMapAbsoluteConfig.formBuilder(copiedFormValues, fromValues$, cropKey, avgNMin, applicationSettings,
              isFieldsForModal, isFormInitializedBefore, this.diagramTemplateRef)
          );
          break;
        case OperationModesEnum.NfTargetMapPerPlan:
          this.targetMapPerPlanConfig.updateFormValuesByParameters(copiedFormValues, selectedFields, applicationSettings);
          fieldSets.push(
            ...this.targetMapPerPlanConfig.formBuilder(copiedFormValues, fromValues$, applicationSettings, isFieldsForModal,
              isFormInitializedBefore, this.diagramTemplateRef)
          );
          break;
        case OperationModesEnum.TargetValue:
          this.targetRateConfig.updateFormValuesByParameters(copiedFormValues, applicationSettings);
          fieldSets.push(
            ...this.targetRateConfig.formBuilder(copiedFormValues, fromValues$, applicationSettings, isFieldsForModal,
              isFormInitializedBefore, this.diagramTemplateRef)
          );
          break;
        case OperationModesEnum.NFertilization:
          this.nFertilizationConfig.updateFormValuesByParameters(copiedFormValues, cropKey, avgNMin, applicationSettings);
          fieldSets.push(
            ...this.nFertilizationConfig.formBuilder(copiedFormValues, fromValues$, applicationSettings, cropKey,
              avgNMin, isFieldsForModal, isFormInitializedBefore, this.diagramTemplateRef)
          );
          break;
        case OperationModesEnum.RapeFertilization:
          this.rapeFertilizationConfig.updateFormValuesByParameters(copiedFormValues, cropKey, avgNMin, applicationSettings);
          fieldSets.push(
            ...this.rapeFertilizationConfig.formBuilderConfig(copiedFormValues, fromValues$, applicationSettings, cropKey,
              avgNMin, isFieldsForModal, isFormInitializedBefore)
          );
          break;
        case OperationModesEnum.Bonitur:
          this.boniturConfig.updateFormValuesByParameters(copiedFormValues, applicationSettings);
          fieldSets.push(
            ...this.boniturConfig.formBuilder(copiedFormValues, applicationSettings, isFieldsForModal, isFormInitializedBefore)
          );
          break;
      }
    } else if (operationModeAppSetting?.ApplicationMode === ApplicationModesEnum.Constant) {
      const totalArea = selectedFields.map(currentItem => Create(currentItem?.Area, 0))
        .reduce((areaSum, currentArea) => areaSum + currentArea, 0);
      fieldSets.push(
        this.uniformConfig.formBuilder(this.dynComponent.dynForm, copiedFormValues, fromValues$, totalArea, isFieldsForModal)
      );
    }
    fieldSets.Add(
      this.generalConfig.getDocuFieldSet(copiedFormValues, fromValues$, this.dynComponent.dynForm.form.getRawValue,
        isFieldsForModal)
    );
    return fieldSets;
  }

  /**
   * Handles the dynamic generation of the details form based on various input parameters,
   * including ECStage values, operation mode settings, and application-specific conditions.
   * This method ensures that ECStage values and operation mode application settings are
   * properly evaluated, applying default values or constraints as necessary while taking into
   * account the user's current selections and system configurations.
   * @return This method does not return a value, but it updates internal states
   * and dependent properties necessary for the form generation process.
   * @private
   */
  private onDetailsFormGeneration(): void {
    if (!Number.isFinite(this._formValues['ECStage'])) {
      const growthStageMinGlobal = +this.agriportConstantsService.GetConstant(AgriportConstantsEnum.EcMin);
      const growthStageMaxGlobal = +this.agriportConstantsService.GetConstant(AgriportConstantsEnum.EcMax);
      const applicationSettings = this.applicationSettingsService.getApplicationSettings(
        this.nPlanningEntryService.appSettingsOperationModes(this._selectedFieldsInfo.IsRapeCrop,
          this._selectedFieldsInfo.HasAnyValidScan), this._selectedFieldsInfo.EppoCode
      );
      const growthStages = applicationSettings.flatMap(x => [x.EcMin, x.EcMax]);
      this._ecStageMinMax = {
        Min: growthStages.reduce((min, stage) => Math.min(min, stage), growthStages.length > 0 ? growthStages[0] : growthStageMinGlobal),
        Max: growthStages.reduce((max, stage) => Math.max(max, stage), growthStages.length > 0 ? growthStages[0] : growthStageMaxGlobal)
      };

      const growthStageFromScans = this.nFertilizationCommonEntryService.getGrowthStageFromScans(this._selectedFields$.getValue());
      this._formValues['ECStage'] = this.nPlanningEntryService.componentData.Summary?.ECValue
        ?? growthStageFromScans ?? this._ecStageMinMax.Min;
      if (this._formValues['ECStage'] < this._ecStageMinMax.Min || this._formValues['ECStage'] > this._ecStageMinMax.Max) {
        this._formValues['ECStage'] = this._ecStageMinMax.Min;
      }
    }
    if (!this._formValues['OperationMode']) {
      const growthStage = this._formValues['ECStage'];
      const operationModeAppSettings = this.getOperationModeAppSettings(this.data.ApplicationMode,
        this._selectedFieldsInfo.EppoCode, growthStage, this._selectedFieldsInfo.IsRapeCrop, this._selectedFieldsInfo.HasAnyValidScan);
      this._operationModeAppSettings$.next(operationModeAppSettings);
      const operationModeFromSummary = this.nPlanningEntryService.componentData.Summary?.OperationMode?.Key as OperationModesEnum;
      this._operationModeAppSetting = operationModeAppSettings.find(x => x.OperationMode === operationModeFromSummary
        && x.ApplicationSetting?.EcMin <= growthStage && x.ApplicationSetting?.EcMax >= growthStage);
      if (!this._operationModeAppSetting) {
        this._operationModeAppSetting = this.nPlanningEntryService.selectedDefaultOperationMode(this.data.ApplicationMode,
          this._selectedFieldsInfo.IsRapeCrop, operationModeAppSettings);
      }
      this._formValues['OperationMode'] = this._operationModeAppSetting?.Id;
    }
    this.nPlanningEntryService.createSummaryAndApplyValues(this.data.ApplicationMode,
      this._operationModeAppSetting.OperationMode, this.data?.PlanBooks, this._formValues);
  }

  private _getFieldSets(dataItem: any, values: any, values$: Observable<any>,
                        operationModeAppSetting: IOperationModeAppSetting | undefined): ApDynformsConfigFieldset[] {
    let fieldSet = [];
    const isFieldsForModal = true;
    const cropKey = this._selectedFieldsInfo.CropTypes?.CropKey;
    const operationMode = operationModeAppSetting.OperationMode;
    const applicationSetting = operationModeAppSetting.ApplicationSetting;
    const selectedFields = this._selectedFields$.getValue();
    const modalDialogValues$ = values$.pipe(delay(0));
    const avgNMin = this.nFertilizationCommonEntryService.getAverageMinFromScans(selectedFields);
    switch (operationMode) {
      case OperationModesEnum.ApplicationMap:
        this.applicationMapConfig.updateFormValuesByParameters(values, selectedFields, applicationSetting);
        fieldSet = fieldSet.concat(
          this.applicationMapConfig.formBuilder(values, modalDialogValues$, applicationSetting, isFieldsForModal,
            false)
        );
        break;
      case OperationModesEnum.ApplicationMapAbsolute:
        this.applicationMapAbsoluteConfig.updateFormValuesByParameters(values, selectedFields, cropKey, avgNMin,
          applicationSetting);
        fieldSet = fieldSet.concat(
          this.applicationMapAbsoluteConfig.formBuilder(values, modalDialogValues$, cropKey, avgNMin,
            applicationSetting, isFieldsForModal, false)
        );
        break;
      case OperationModesEnum.NfTargetMapPerPlan:
        this.targetMapPerPlanConfig.updateFormValuesByParameters(values, selectedFields, applicationSetting);
        fieldSet = fieldSet.concat(
          this.targetMapPerPlanConfig.formBuilder(values, modalDialogValues$, applicationSetting,
            isFieldsForModal, false)
        );
        break;
      case OperationModesEnum.TargetValue:
        this.targetRateConfig.updateFormValuesByParameters(values, applicationSetting);
        fieldSet = fieldSet.concat(
          this.targetRateConfig.formBuilder(values, modalDialogValues$, applicationSetting, isFieldsForModal,
            false)
        );
        break;
      case OperationModesEnum.NFertilization:
        this.nFertilizationConfig.updateFormValuesByParameters(values, cropKey, avgNMin, applicationSetting);
        fieldSet = fieldSet.concat(
          this.nFertilizationConfig.formBuilder(values, modalDialogValues$, applicationSetting, cropKey, avgNMin,
            isFieldsForModal, false)
        );
        break;
      case OperationModesEnum.RapeFertilization:
        this.rapeFertilizationConfig.updateFormValuesByParameters(values, cropKey, avgNMin, applicationSetting);
        fieldSet = fieldSet.concat(
          this.rapeFertilizationConfig.formBuilderConfig(values, modalDialogValues$, applicationSetting,
            cropKey, avgNMin, isFieldsForModal, false)
        );
        break;
      case OperationModesEnum.Bonitur:
        this.rapeFertilizationConfig.updateFormValuesByParameters(values, cropKey, avgNMin, applicationSetting);
        fieldSet = fieldSet.concat(
          this.boniturConfig.formBuilder(values, applicationSetting, isFieldsForModal, false)
        );
        break;
      case OperationModesEnum.Constant:
        const totalArea = selectedFields.map(currentItem => Create(currentItem?.Area, 0))
          .reduce((areaSum, currentArea) => areaSum + currentArea, 0);
        fieldSet = fieldSet.concat(
          this.uniformConfig.formBuilder(undefined, values, modalDialogValues$, totalArea, isFieldsForModal)
        );
        break;
    }
    fieldSet.Add(
      this.generalConfig.modalDialogDocuFieldSet(dataItem, values$.pipe(delay(0)))
    );
    return fieldSet;
  }

  private _getStatus(fieldGeom: IFieldGeom, campaignYear: ICampaignYear,
                     sensorData: ISensorFieldData, cropType: ICropTypes | undefined): IGridStatus {
    const geomStatus = this.fieldService.getGeomStatus(fieldGeom, campaignYear);
    if (geomStatus === -1) {
      return {
        state: -1,
        class: 'ap-status-red',
        description: ''
      };
    }
    // Calculate status => APV49-2363
    if (cropType && cropType.IsSensorCrop === true && (!sensorData || sensorData?.CropKey < 1 || cropType.CropKey === sensorData?.CropKey || cropType.Eppocode === sensorData?.EppoCode)) {
      return {
        state: 1,
        class: 'ap-status-green',
        description: 'Global__Variable_Planning_Possible'
      };
    } else if (!cropType || cropType?.Id < 0) {
      return {
        state: 0,
        class: 'ap-status-yellow',
        description: 'Global__No_Var_Planning_Crop'
      };
    } else if (cropType && !cropType?.IsSensorCrop) {
      return {
        state: 0,
        class: 'ap-status-yellow',
        description: 'Global__No_Var_Planning_SensorCrop'
      };
    } else if (cropType && sensorData && cropType.Id !== sensorData.CroptypeId) {
      return {
        state: 0,
        class: 'ap-status-yellow',
        description: 'Global__Crop_not_equals_SensorCrop'
      };
    } else {
      return {
        state: -1,
        class: 'ap-status-red',
        description: ''
      };
    }
  }

  /**
   * Retrieves the application settings for the given operation mode based on the provided parameters.
   * @param applicationMode - The mode of application to determine the operation mode settings.
   * @param eppoCode - The EPPO code associated with the application settings.
   * @param growthStage - An array of growth stages applicable to the operation mode.
   * @param isRapeCrop - Indicates if the crop is a rape crop.
   * @param hasAnyValidScan - Specifies if any valid scan data is available.
   * @return A list of operation mode application settings matched to the given parameters.
   * @private
   */
  private getOperationModeAppSettings(applicationMode: ApplicationModesEnum, eppoCode: string, growthStage: number,
                                      isRapeCrop: boolean, hasAnyValidScan: boolean): IOperationModeAppSetting[] {
    switch (applicationMode) {
      case ApplicationModesEnum.Constant:
        return [{
          Id: OperationModesEnum.Constant,
          OperationMode: OperationModesEnum.Constant,
          ApplicationMode: ApplicationModesEnum.Constant,
          Text: OperationModesEnum.Constant,
          Category: 'OperationMode_Group_Map',
          ApplicationSetting: undefined
        }];
      case ApplicationModesEnum.Variable: {
        const result: IOperationModeAppSetting[] = [];
        for (const operationMode of this.nPlanningEntryService.appSettingsOperationModes(isRapeCrop, hasAnyValidScan)) {
          const applicationSettings = this.applicationSettingsService.getApplicationSettings(
            operationMode, eppoCode, [growthStage]
          );
          for (const applicationSetting of applicationSettings) {
            const id = `${operationMode}-${applicationSetting.Id}`;
            const applicationSettingName = applicationSetting.TranslationKey != null
              ? ` (${this.translationStore.FindTranslationForSelectedLanguage(applicationSetting.TranslationKey)})`
              : '';
            result.push({
              Id: id,
              OperationMode: operationMode,
              ApplicationMode: ApplicationModesEnum.Variable,
              Text: `${this.translationStore.FindTranslationForSelectedLanguage(operationMode)}${applicationSettingName}`,
              Category: this.nPlanningEntryService.getCategoryForOperationMode(operationMode),
              ApplicationSetting: applicationSetting
            });
          }
        }
        return result;
      }
    }
  }

  private _canSaveCheck(canSave: boolean): void {
    if (canSave && this.nFertilizationPlantProtectionService.isOperationModeAnyOfMapsOrConstant(this._operationModeAppSetting.OperationMode)) {
      const stat = this.nFertilizationStore.Listen(s => s.fieldNPlanningStatistic).getValue();
      if (stat === null || stat.length === 0) {
        return;
      }
      const ids = stat.map(_ => _.PlanId);
      this.mapStore.Layers.NApplicationMapLayer.Visibility = true;
      this.mapStore.Layers.NPlanningLayerSourceInit(this.routerStore.Listen(s => s.url).getValue(), ids);
      const statistic = {
        Max: stat.Reduce((target, ele) => {
          if (ele.Max > target) {
            return ele.Max;
          }
          return target;
        }, 0),
        ElementId: 5,
        ProductId: this._formValues['Product'],
        Min: stat.Reduce((target, ele) => {
          return target < ele.Min ? target : ele.Min;
        }, stat.FirstOrDefault().Min),
        Average: stat.Reduce((target, ele) => {
          if (target < ele.Mean) {
            return ele.Mean;
          }
          return target;
        }, 0)
      };
      if (statistic.Average === 0) {
        this._clearMap();
      } else {
        this.mapStore.Legends.onNPlanningChanged.emit(statistic);
      }
    }
  }

  private _save(): void {
    const counts = this.items$.getValue().reduce((acc, item) => {
      if (item['ECStage'] in acc) {
        acc[item['ECStage']]++;
      } else {
        acc[item['ECStage']] = 1;
      }
      return acc;
    }, {});
    let mostFrequentValue = null;
    let highestCount = 0;
    for (const value in counts) {
      if (counts[value] > highestCount) {
        highestCount = counts[value];
        mostFrequentValue = value;
      }
    }
    const formsOperationMode = this._operationModeAppSetting?.OperationMode;
    const formApplicationMode = this.data.ApplicationMode;
    const summaryApplicationMode = this.applicationModesStore.Listen(s => s.data).getValue().Find((a) => a.Key === formApplicationMode);
    const summaryOperationMode = this.operationModesStore.Listen(s => s.data).getValue().Find((o) => o.Key === formsOperationMode);

    const inputTargetRate = ApObjectHelper.accessObjectKey(this._formValues, 'TargetRate', 'number', 0);
    const inputConstant = ApObjectHelper.accessObjectKey(this._formValues, 'Constant', 'number', 0);

    // Do the _summaryForEdit plain or simple in the file
    const summary = {
      ApplicationDate: this.dateService.getDateNoon(this._formValues['FertilizationDate']),
      AdditionalValue: {
        DeadBiomass: this._formValues['DeadBioMass'] ?? null,
        NMinPotential: this._formValues['Potential'] ?? null,
        ExpectedYield: this.nFertilizationCommonEntryService.getYieldExpectation(
          this._operationModeAppSetting.OperationMode, this._formValues['YieldExpectation']
        ) ?? null
      },
      ApplicationMode: summaryApplicationMode,
      ECValue: mostFrequentValue,
      OperationMode: summaryOperationMode,
      Slope: this.nFertilizationPlantProtectionService.getSlope(formsOperationMode, this._formValues['ControlFactor'],
        this._selectedFieldsInfo.IsRapeCrop, this._operationModeAppSetting?.ApplicationSetting),
      Threshold: this._formValues['Threshold'],
      Title: this._formValues['Note'] ?? '',
      Unit: this.unitStore.getUnit('kgN/ha'),
      UserApplicationConstant: summaryOperationMode.Key === OperationModesEnum.TargetValue
        ? inputTargetRate : inputConstant,
      UserApplicationMaximum: summaryApplicationMode.Key !== ApplicationModesEnum.Constant
        ? summaryOperationMode.Key !== OperationModesEnum.TargetValue
          ? this._formValues['Maximum']
          : inputTargetRate + this._formValues['ControlRange']
        : inputConstant,
      UserApplicationMinimum: summaryApplicationMode.Key !== ApplicationModesEnum.Constant
        ? summaryOperationMode.Key !== OperationModesEnum.TargetValue
          ? this._formValues['Minimum']
          : inputTargetRate - this._formValues['ControlRange']
        : inputConstant,
      UserApplicationRate: summaryApplicationMode.Key !== ApplicationModesEnum.Constant
        ? summaryOperationMode.Key !== OperationModesEnum.TargetValue
          ? this._formValues['Amount']
          : inputTargetRate
        : inputConstant,
      FarmId: this.loginStore.SelectedFarmId,
    } as INFertilizationSummary;
    const fields = this._selectedFields$.getValue();
    const planBooks = this.items$.getValue().map((item) => {
      const field = fields.find((f) => f.Id === item.Id);
      const nPlanningPlanBookData = this._getNPlanningPlanBookData(field.Geom.Id);
      const planId = item.PlanId !== undefined ? item.PlanId : ApGuidUtil.getEmptyGuid();
      const planBookApplicationMode = this.applicationModesStore.Listen(s => s.data).getValue().Find((a) => a.Key === item.ApplicationMode);
      const planBookOperationMode = this.operationModesStore.Listen(s => s.data).getValue().Find((o) => o.Key === item.OperationMode);
      return {
        Id: planId,
        ProductId: !this._formValues['Product'] ? 0 : this._formValues['Product'],
        ApplicationMode: planBookApplicationMode,
        OperationMode: planBookOperationMode,
        FieldGeomId: field.Geom.Id,
        MainCropId: field.CropId,
        Note: item['Note'],
        ApplicationDate: this.dateService.getDateNoon(item['Date']),
        ApplicationConst: item['Constant'],
        ApplicationMax: planBookApplicationMode.Key === ApplicationModesEnum.Constant ? item['Constant'] : item['Maximum'],
        ApplicationMin: planBookApplicationMode.Key === ApplicationModesEnum.Constant ? item['Constant'] : item['Minimum'],
        ApplicationRate: item['TargetRate']
          ? item['TargetRate']
          : (planBookApplicationMode.Key === ApplicationModesEnum.Constant ? item['Constant'] : item['Amount']),
        ECValue: +item['ECStage'],
        Element: ApElementType.N,
        Factor: 1,
        Slope: nPlanningPlanBookData.ControlFactor,
        SecondCropId: field.SecondCropId,
        Summary: summary,
        Threshold: nPlanningPlanBookData.Threshold,
        FarmId: this.loginStore.SelectedFarmId,
        FieldId: item.Id,
        ExportDriver: item['Driver']?.Id ?? null,
        ExportMachine: item['Machine']?.Id ?? null,
        ExportInstrument: item['Instrument']?.Id ?? null,
        Geom: this.fieldStore.getCurrentFieldGeom(field.Id.toString())?.Geom,
        Unit: this.unitStore.getUnit('kgN/ha'),
        JobInput: JSON.stringify(item['ScanData']),
        Duration: ApTimeSpanUtil.getTimeSpanFromMilliseconds(nPlanningPlanBookData.DurationInMilliseconds, true)
      } as INFertilizationPlanBook;
    });
    this.nFertilizationStore.SaveNFertilizationPlanning(planBooks);
  }

  private _isRemainingValueCouldBeApplied(operationModeKey: string): boolean {
    return this.nFertilizationCommonEntryService.isOperationModeGroupMapButNotConst(operationModeKey as OperationModesEnum)
      || operationModeKey === OperationModesEnum.Constant
      || operationModeKey === OperationModesEnum.TargetValue;
  }

  private _updateOverviewItems(submitData: { ids: any[], value: any }): void {
    this.items$.getValue().forEach((planBookGridItem) => {
      if (submitData.ids.includes(planBookGridItem.Id)) {
        const date = planBookGridItem.Date;
        const copiedPlanBookGridItem = ObjectFactory.Copy(planBookGridItem);
        const copiedSubmitDataValue = ObjectFactory.Copy(submitData.value);
        planBookGridItem = ObjectFactory.Merge(copiedPlanBookGridItem, copiedSubmitDataValue);
        planBookGridItem.Date = date;
        if (planBookGridItem['OperationMode'] === OperationModesEnum.TargetValue) {
          planBookGridItem['Minimum'] = planBookGridItem['TargetRate'] - planBookGridItem['ControlRange'];
          planBookGridItem['Maximum'] = planBookGridItem['TargetRate'] + planBookGridItem['ControlRange'];
          planBookGridItem['Constant'] = planBookGridItem['TargetRate'];
        }
        const planBook = this._getNPlanningPlanBookData(planBookGridItem['Geom']?.Id);
        const field = this._selectedFields$.getValue().find(x => x.Id === planBook.FieldId);
        const fieldGeom = this.fieldStore.getFieldGeomById(planBook.FieldGeomId);
        planBook.ErrorMessage = '';
        planBook.HasError = false;
        planBook.ECStage = Number.isFinite(planBookGridItem['ECStage']) ? planBookGridItem['ECStage'] : planBook.ECStage;
        planBook.Minimum = Number.isFinite(planBookGridItem['Minimum']) ? planBookGridItem['Minimum'] : planBook.Minimum;
        planBook.Maximum = Number.isFinite(planBookGridItem['Maximum']) ? planBookGridItem['Maximum'] : planBook.Maximum;
        planBook.Threshold = Number.isFinite(planBookGridItem['Threshold']) ? planBookGridItem['Threshold'] : planBook.Threshold;
        planBook.ControlFactor = Number.isFinite(planBookGridItem['ControlFactor']) ? planBookGridItem['ControlFactor'] : planBook.ControlFactor;
        planBook.ControlFactorDescription = this.nFertilizationPlantProtectionService.getControlFactorDescription(
          this._operationModeAppSetting?.OperationMode, planBook.ControlFactor,
          this._operationModeAppSetting?.ApplicationSetting, false);
        planBook.Amount = Number.isFinite(planBookGridItem['TargetRate']) ? planBookGridItem['TargetRate'] : planBookGridItem['Amount'];
        planBook.Constant = planBookGridItem['Constant'];
        planBook.DeadBioMass = planBookGridItem['DeadBioMass'];
        planBook.Driver = planBookGridItem['Driver'];
        planBook.Instrument = planBookGridItem['Instrument'];
        planBook.Machine = planBookGridItem['Machine'];
        planBook.Note = planBookGridItem['Note'];
        planBook.HaPerHour = planBookGridItem['HaPerHour'];
        planBook.ProductAmount = planBookGridItem['ProductAmount'];
        planBook.ProductAmountPerHa = planBookGridItem['ProductAmountPerHa'];
        planBook.DurationInMilliseconds = this.timeAreaService.getTotalDurationInMilliseconds(fieldGeom?.AreaHa, planBookGridItem['HaPerHour']);
        if (this._operationModeAppSetting?.OperationMode === OperationModesEnum.TargetValue) {
          planBook.ControlRange = Number.isFinite(planBookGridItem['ControlRange']) ? planBookGridItem['ControlRange'] : planBook.ControlRange;
          planBook.TargetRate = Number.isFinite(planBookGridItem['TargetRate']) ? planBookGridItem['TargetRate'] : planBook.TargetRate;
        }
        if (planBook.OperationModeKey === OperationModesEnum.ApplicationMap) {
          planBook.JobNUptake = field.ScanData.NUptakeAvg;
          planBook.ThresholdAbs = planBook.JobNUptake * (planBook.Threshold / 100);
        }
        if (planBook.OperationModeKey === OperationModesEnum.NfTargetMapPerPlan) {
          planBook.JobNUptake = this.nFertilizationPlantProtectionService.calculateAreaWeightedAverageOfScans(
            this._selectedFields$.getValue(), this._operationModeAppSetting?.ApplicationSetting);
          planBook.ThresholdAbs = planBook.JobNUptake * (planBook.Threshold / 100);
        }
        if (this.nFertilizationPlantProtectionService.isOperationModeAnyOfMapsOrConstant(this._operationModeAppSetting?.OperationMode)) {
          planBook.ColumnLoading = true;
          this._initializeGridOverviewItem(true, false);
          this._createNPlanningRasterJob(
            planBook.PlanId,
            planBook.ScanData,
            planBook.FieldGeomId,
            this.applicationModesStore.Listen(s => s.data).getValue().Find((a) => a.Key === planBookGridItem['ApplicationMode']).Id,
            planBook.JobNUptake ?? null,
            planBook.Minimum,
            planBook.Maximum,
            planBook.ThresholdAbs ?? planBook.Threshold,
            planBook.ControlFactor,
            planBook.Amount,
            planBook.Constant,
            planBook.DeadBioMass
          );
        } else {
          this._initializeGridOverviewItem(false, false);
        }
      }
    });
  }

  private _createNPlanningRasterJob(planId: IGuid, bestScan: BestScanData, fieldGeomId: IGuid, applicationMode: number,
                                    nUptake: number | undefined, minimum: number, maximum: number, threshold: number,
                                    slope: number, applRate: number, constant: number, deadBioMass: number): void {
    const nFertPlanId = bestScan?.ScanType === BestScanType.NFertilizationSensor
      ? bestScan.PlanId : ApGuidUtil.getEmptyGuid();
    const ppPlanId = bestScan?.ScanType === BestScanType.PlantProtectionSensor
      ? bestScan.PlanId : ApGuidUtil.getEmptyGuid();
    const satelliteId = bestScan?.ScanType === BestScanType.SatelliteScan
      ? bestScan.SatId : ApGuidUtil.getEmptyGuid();
    const satelliteScanType = bestScan?.ScanType === BestScanType.SatelliteScan && bestScan?.SatelliteScan === ScanType.Autumn
      ? ScanType.Autumn : ScanType.Regular;
    const planningData: INPlanningData = {
      PlanId: planId,
      NdPlanId: nFertPlanId,
      PpPlanId: ppPlanId,
      SatId: satelliteId,
      AutumnScan: satelliteScanType,
      NUptake: nUptake ?? null,
      FieldGeomId: fieldGeomId,
      ApplicationMode: applicationMode,
      Minimum: minimum,
      Maximum: maximum,
      Constant: constant,
      Slope: slope,
      DeadBioMass: deadBioMass ?? 0,
      Threshold: threshold,
      // use juggle-check for null and undefined check and additional check for isFinite().
      // The "+" operator does not handle undefined cases properly - the result would be "NaN"
      ApplRate: (applRate != null && isFinite(+applRate)) ? +applRate : 0
    };
    this.nFertilizationStore.CreateNPlanningRasterJob(planningData);
  }

  private _createNPlanningJob(): void {
    this._clearMap();
    this._nPlanBooks.forEach((item) => {
      const applicationMode = this.applicationModesStore.Listen(s => s.data).getValue().Find((a) => a.Key === item.ApplicationModeKey);
      this._createNPlanningRasterJob(
        item.PlanId,
        item.ScanData,
        item.FieldGeomId,
        applicationMode.Id,
        item.JobNUptake ?? null,
        item.Minimum,
        item.Maximum,
        item.ThresholdAbs ?? item.Threshold,
        item.ControlFactor,
        item.OperationModeKey === OperationModesEnum.Constant
          ? 0
          : item.TargetRate ? item.TargetRate : item.Amount,
        item.Constant,
        item.DeadBioMass
      );
    });
  }

  private _clearMap(): void {
    MapFactoryStyler.Instance.clearStyleCache();
    this.mapStore.Layers.NApplicationMapLayer.clear();
    this.mapStore.Layers.Clear();
    this.mapStore.Legends.removeLegend(this.mapStore.Legends.NPlanningLegend);
  }

  private _fieldSelection(): void {
    if (this._currentStep === ApBaseWizardSteps.Selection) {
      let selectedFieldIds: string[];
      const selectedFieldItems = (this.dynComponent.getSelectedItems() as INFertilizationPlanFieldToSelectGridItem[]);
      if (selectedFieldItems?.length > 0) {
        selectedFieldIds = selectedFieldItems.map(x => x.Id.toString());
        this.fieldStore.changeSelectedField(selectedFieldIds);
      }
      return;
    }
    if (this._currentStep === ApBaseWizardSteps.Overview) {
      let selectedFieldIds: string[];
      const selectedPlanFields = this.dynComponent.getSelectedItems();
      if (selectedPlanFields?.length > 0) {
        selectedFieldIds = selectedPlanFields.map(x => x.Id.toString());
      } else {
        selectedFieldIds = this.dynComponent.items.map(x => x.Id.toString());
      }
      this.fieldStore.changeSelectedField(selectedFieldIds);
    }
  }

  private _generateStats(): void {
    if (this._currentStep === ApBaseWizardSteps.Selection) {
      // TODO: We need a proper model for the items here. Until refactoring, we use any.
      let items = this.dynComponent.getSelectedItems() as INFertilizationPlanFieldToSelectGridItem[];
      if (!items || items.length <= 0) {
        // fallback => uses all if nothing is selected
        items = this.dynComponent.items as INFertilizationPlanFieldToSelectGridItem[];
      }
      // put it on top of the callstack to avoid lagging when the user changes the selection
      setTimeout(() => {
        this.nPlanningEntryService.generateFieldStatistic(items);
      });
      return;
    }
    if (this._currentStep === ApBaseWizardSteps.Details) {
      // put it on top of the callstack to avoid lagging when the user changes the selection
      setTimeout(() => {
        this.nPlanningEntryService.generateFieldStatistic(this._selectedFields$.getValue());
      });
      return;
    }
    if (this._currentStep === ApBaseWizardSteps.Overview
      && this.nFertilizationPlantProtectionService.isOperationModeAnyOfMapsOrConstant(this._operationModeAppSetting?.OperationMode)) {
      // put it on top of the callstack to avoid lagging when the user changes the selection
      setTimeout(() => {
        this.nPlanningEntryService.generateOverviewStatistic(this._operationModeAppSetting?.OperationMode,
          this.dynComponent.getSelectedItems(), this.dynComponent.items);
      });
      return;
    }
    this.statisticStore.removeStatisticData();
  }

  private _onCloseForm(): void {
    this._clearMap();
    this.statisticStore.removeStatisticData();
    setTimeout(() => this.formStore.closeForm(), 1);
  }

  private getDefaultBestScanStatus(): IGridStatus {
    return {
      state: ApColumnState.Red,
      class: 'ap-status-grey',
      description: ''
    };
  }

  private preventGoBack(_event: any): void {
    history.go(1);
  }
}
